import { Box, Grid, Link, Typography } from '@mui/material';
import { FC } from 'react';
import { RoundedPaper } from '../../lib/components';
import GooglePlay from '../../lib/images/google-play.svg?react';
import AppStore from '../../lib/images/app-store.svg?react';
import { link } from '../../misc/globals';
import { Trans, useTranslation } from 'react-i18next';
import { LoginLogo } from './partials/LoginLogo';

export const WelcomeEmployee: FC = () => {
  const { t } = useTranslation('welcome');

  return (
    <Box
      sx={{
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: '24px',
          padding: '0 32px 32px 32px',
          margin: '84px auto',
          maxWidth: '500px',
          maxHeight: '100vh'
        }}
      >
        <LoginLogo />
        <RoundedPaper sx={{ padding: 3, marginBottom: 2, textAlign: 'left' }}>
          <Typography variant="h3" component={'h3'} paddingBottom={2}>
            {t('TITLE')}
          </Typography>
          <Typography paragraph>
            <Trans i18nKey={'welcome:TEXT'} components={{ bold: <strong /> }} />
          </Typography>
        </RoundedPaper>
        <RoundedPaper
          sx={{
            paddingX: 3,
            paddingTop: 3,
            paddingBottom: 2.5,
            backgroundColor: 'heaven.main',
            color: 'white'
          }}
        >
          <Grid container columnSpacing={1} rowSpacing={2}>
            <Grid
              item
              xs={12}
              sm={4}
              marginTop={0.5}
              sx={{ textAlign: { xs: 'center', sm: 'initial' } }}
            >
              <Typography color="inherit">{t('DOWNLOAD_NOW')}</Typography>
              <Typography color="inherit" sx={{ fontSize: '20px' }}>
                {t('APP')}
              </Typography>
            </Grid>
            <Grid item xs={1} sx={{ display: { sm: 'none' } }} />
            <Grid item xs={10} sm={4} marginBottom={0.5}>
              <Link href={link.appstore}>
                <AppStore height="inherit" width="inherit" />
              </Link>
            </Grid>
            <Grid item xs={1} sx={{ display: { sm: 'none' } }} />
            <Grid item xs={1} sx={{ display: { sm: 'none' } }} />{' '}
            <Grid item xs={10} sm={4} marginBottom={0.5}>
              <Link href={link.playstore}>
                <GooglePlay height="inherit" width="inherit" />
              </Link>
            </Grid>
          </Grid>
          <Box></Box>
        </RoundedPaper>
      </Box>
    </Box>
  );
};
